import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';

export const TargetAudienceSection = () => {
  const pertinentIf = [
    "Vous souhaitez développer une offre, une clientèle ou un positionnement précis",
    "Votre message ne reflète plus complètement votre entreprise",
    "Vous constatez des incompréhensions ou objections récurrentes",
    "Vous envisagez une refonte, mais ne savez pas encore ce qui doit être changé",
    "Vous pensez que la qualité de votre entreprise est insuffisamment perçue"
  ];

  return (
    <section className="py-32 bg-gray-50 relative">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto fade-in-section">
          <h2 className="section-title mb-16 text-center">
            Cette intervention est<br />
            <span className="text-accent">pertinente si</span>…
          </h2>

          {/* Liste positive */}
          <div className="space-y-4 mb-12">
            {pertinentIf.map((item, index) => (
              <div 
                key={index}
                className="flex items-start gap-4 p-5 bg-white rounded-lg border border-gray-200"
              >
                <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-green-100 rounded-full mt-0.5">
                  <CheckCircle2 className="h-4 w-4 text-green-600" />
                </div>
                <p className="text-gray-700 leading-relaxed">
                  {item}
                </p>
              </div>
            ))}
          </div>

          {/* Section négative */}
          <div className="p-8 bg-white border-2 border-gray-200 rounded-lg">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <XCircle className="h-6 w-6 text-gray-400" />
              </div>
              <div>
                <p className="text-gray-700 leading-relaxed mb-2">
                  <span className="font-semibold">Cette intervention n'est probablement pas prioritaire si</span> vous recherchez uniquement un nouveau logo, quelques publications sur les réseaux sociaux ou une exécution graphique sans remise en question préalable.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TargetAudienceSection;
